module.exports = __webpack_public_path__ + "static/media/stethophyma_grossum_002_APA.3bc44a6f.mp3";